import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../firebase/AuthProvider";
import { BrandLoader } from "../../ui/Logo/BrandLoader";

const Logout: React.FC = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const hasStartedRef = useRef(false);

  useEffect(() => {
    if (hasStartedRef.current) return;

    hasStartedRef.current = true;
    void logout().finally(() => {
      navigate("/login", { replace: true });
    });
  }, [logout, navigate]);

  return <BrandLoader fullScreen />;
};

export default Logout;
